import React, { useMemo } from "react";
import { OfferRentStatusDropdownProps } from "./types";
import { DropdownOption } from "../Dropdown/types";
import { getOfferRentStatusesAPI } from "services/api/fleet/vehicles/offers/api";
import { OfferRentStatus } from "services/api/fleet/vehicles/offers/types";
import { Dropdown } from "../Dropdown";
import { getStatusCircleColor } from "../OfferSaleStatusDropdown/consts";
import { DropdownCacheKey, useDropdownCache } from "services/hooks/useDropdownCache";

const THIRTY_MINUTES = 30 * 60 * 1000;

const OfferRentStatusDropdown: React.FC<OfferRentStatusDropdownProps> = (
  props: OfferRentStatusDropdownProps
) => {
  const {
    name,
    disabled,
    required,
    label,
    error,
    value,
    direction,
    width,
    height,
    placeholder,
    onChange,
  } = props;

  const { data } = useDropdownCache<OfferRentStatus[]>(
    DropdownCacheKey.OfferRentStatuses,
    getOfferRentStatusesAPI,
    THIRTY_MINUTES
  );

  const statusOptions: DropdownOption[] = useMemo(
    () =>
      (data ?? []).map((status) => ({
        value: status.id,
        text: (
          <div className="flex items-center gap-2">
            <span className={`w-2.5 h-2.5 rounded-full inline-block ${getStatusCircleColor(status.color)}`} />
            <span>{status.name}</span>
          </div>
        ),
      })),
    [data]
  );

  return (
    <Dropdown
      label={label}
      name={name}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      value={value}
      direction={direction}
      width={width}
      height={height}
      options={statusOptions}
      onChange={onChange}
      error={error}
    />
  );
};

export default React.memo(OfferRentStatusDropdown);
